import React, { useState, useRef, useEffect } from "react";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import Sidebar from "./common/Sidebar";
import { BankNameProvider } from '../context/BankNameContext';

function DashboardLayout({ children }) {

  const [isLeftPanelVisible, setIsLeftPanelVisible] = useState(false);
  const sidebarRef = useRef(null);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsLeftPanelVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return() => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <BankNameProvider>
    <div className="dashboard-layout">
      <div className={`left-panel ${!isLeftPanelVisible ? `hide-left-panel-mobile` : ``}`} ref={sidebarRef}>
        <Sidebar setIsLeftPanelVisible={setIsLeftPanelVisible}/>
      </div>
      <div className="right-panel">
        <Header setIsLeftPanelVisible={setIsLeftPanelVisible}/>
        {children}
      </div>
      <Footer />
    </div>
    </BankNameProvider>
  );
}

export default DashboardLayout;
